/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import { TbCircle, TbPolygon, TbRectangle } from 'react-icons/tb'

import { SHAPE_LABELS, type ShapeType } from '../types'

const ICONS = { polygon: TbPolygon, rectangle: TbRectangle, circle: TbCircle }

export const ShapeIcon = ({ type, className = '' }: { type: ShapeType; className?: string }) => {
  const Icon = ICONS[type]
  return <Icon className={`size-4 ${className}`} title={SHAPE_LABELS[type]} aria-label={SHAPE_LABELS[type]} />
}
